/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useState } from 'react';
import QuickSubscription from '../../../components/ContentBlocks/QuickSubscription';
import { crashReporter } from '../../../utils/crashReporter';
import { EMAIL } from '@/utils/validatorRegex';
import azURL from './../../../config/serviceAPI';
import { clickTrack } from '@/utils/analytics/clickTrack';
import { getAxiosForClient } from '@/lib/axios';
import { useLabels } from '@/hooks/useLabels';

const trackNewsLetterSubscribeHome = (email: string) => {
  clickTrack({
    emailaddress: email,
    eventType: 'newsletterSignupHome',
  });
};

const labelMap = {
  lblEmailFieldRequired: 'label_email_field_required',
  lblEmailInvalid: 'label_email_not_valid_format',
};

export const EmailSignup = () => {
  const [email, setEmail] = useState('');
  const [lblError, setLblError] = useState<string>('');
  const [errorEmail, setErrorEmail] = useState(false);
  const [signUpSuccess, setSignUpSuccess] = useState(false);

  const labels = useLabels(labelMap);

  const signUp = (emailValue: string) => {
    const emailId = emailValue;

    getAxiosForClient()
      .post(azURL('quickSubscribe'), {
        email: emailValue,
      })
      .then(({ data }) => {
        setEmail('');
        setLblError('');
        setSignUpSuccess(data.success);
        trackNewsLetterSubscribeHome(emailId);
      })
      .catch((err) => {
        setErrorEmail(true);
        crashReporter('An error occurred in the quickSubscribe block', '', err);
      });
  };

  const validateEmail = () => {
    let error: string = '';
    let hasError = false;

    if (!email || email.trim() === '') {
      error = labels.lblEmailFieldRequired;
      hasError = true;
    } else if (!EMAIL.test(email)) {
      error = labels.lblEmailInvalid;
      hasError = true;
    } else {
      signUp(email);
    }

    setLblError(error);
    setErrorEmail(hasError);
  };

  const handleEmailChange = (event: any) => {
    setEmail(event.target.value);
  };

  return (
    <QuickSubscription
      validateEmail={validateEmail}
      handleEmailChange={handleEmailChange}
      email={email}
      lblError={lblError}
      errorEmail={errorEmail}
      signUpSuccess={signUpSuccess}
    />
  );
};
